import { Component } from '@angular/core';
import { Router } from '@angular/router';
// import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic'; // CKEditor build


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'pms';
  // public Editor = ClassicEditor;
  // public editorData = '<p>Type your content here...</p>';
  constructor(
    private router: Router,
  ) {

  }
  ngOnInit() {
    if (localStorage.getItem('email') === undefined || localStorage.getItem('email') === null || localStorage.getItem('email') === '') {
      this.router.navigateByUrl('/login');
    }
  }

}
